import { ILicensingInfo } from '../types/ILicensingInfo';
import { Request } from './Request';

export interface IGetLicensingInfoParams {
}

export interface IGetLicensingInfoResult extends ILicensingInfo {
}

export class GetLicensingInfoRequest extends Request<IGetLicensingInfoParams, IGetLicensingInfoResult> {
  constructor(params: IGetLicensingInfoParams = {}) {
    super('getLicensingInfo', params);
  }
}
